import React, { Component } from 'react';

class LoadingSpinner extends Component {
  render() {
    return (
      <div className="loading-spinner">Loading...</div>
    )
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js